// extracted by mini-css-extract-plugin
module.exports = {"Container":"IconInput_Container__3fEoI","Label":"IconInput_Label__1YCHT","Icon":"IconInput_Icon__1cZVa","Checked":"IconInput_Checked__2Mv3b"};